/**
 * Copyright © 2026 Adnuntius AS.
 * UI-Router state declarations.
 */
import {Ng2StateDeclaration} from '@uirouter/angular';
import {collectStatesFromProvider, AdnRouterHelperApi} from '../routing/state-utils';
import {RouteTwoPanelLayoutComponent} from '../common/directives/route-two-panel-layout.component';
import {LineItemTemplateContextActionsComponent} from './line-item-template-context-actions.component';
import {AdminResourceItemRoutePageComponent} from '../common/controller/admin-resource-item-route-page.component';
import {LineItemTemplateResource} from '../../components/api/resources/resource/line-item.resource';

const listTemplate = '<adn-line-item-template-list-page [list]="list"></adn-line-item-template-list-page>';



export function lineItemTemplateStates(adnRouterHelper: AdnRouterHelperApi): Ng2StateDeclaration[] {
  return collectStatesFromProvider(function register($stateProvider, adnRouterHelperProvider) {
const rh = adnRouterHelperProvider.$get().createRouterHelper('line-item-templates.line-item-template', LineItemTemplateResource,  'app.adv', 'app', listTemplate);
        $stateProvider.state(rh.listPath(), rh.list({
          resolve: {
            extension: /*@ngInject*/ function() {
              const LocalNetworkProfile = adnRouterHelper.services.localNetworkProfile();

              return {
                func: function(ctrl) {
                  ctrl.hasObjectSource = LocalNetworkProfile.hasObjectSource();
                  ctrl.lineItemFields = ['name', {label: 'tier', param: 'Tier'}, {param: 'objectives', numeric: true}, {param: '', label: 'targeting'}];
                }
              };
            },
            bulk: function() {
              return {};
            },
            sectionParam: function() {
              return 'lineItems';
            }
          }
        }))
          .state(rh.newItemPath(), rh.newItem())
          .state(rh.itemPath(), rh.modelCommsItem({
            resolve: {
              advertiserFromParam: function() {
              },
              orderFromParam: function() {
              },
              lineItemView: function() {
                return null;
              },
              full: function() {
                return false;
              },
              viewType: function() {
                return 1;
              },
              leftPanelFull: function() {
                return false;
              },
              lineItemTemplateEditRouteKey: function() {
                return 'line-item-edit';
              },
              lineItemTemplateAnalysisRouteKey: function() {
                return 'line-item-template-analysis-edit';
              },
              routeEditVariant: function() {
                return 'edit';
              },
              lineItemTemplateEditInputs: /*@ngInject*/ function(
                viewType, orderFromParam, advertiserFromParam, lineItemView
              ) {
                return {full: false, viewType, orderFromParam, advertiserFromParam, lineItemView};
              },
              model: /*@ngInject*/ function($stateParams) {
                if ($stateParams.isNew) {
                  return adnRouterHelper.services.resource(LineItemTemplateResource).create({
                    id: $stateParams.id
                  });
                }
                return adnRouterHelper.services.resource(LineItemTemplateResource).get({id: $stateParams.id}).$promise;
              }
            },
            views: {
              'content@app': {
                component: RouteTwoPanelLayoutComponent,
                bindings: {full: 'full', modelComms: 'modelComms'}
              },
              'rightPanel@app.adv.line-item-templates.line-item-template': {
                component: AdminResourceItemRoutePageComponent,
                bindings: {item: 'lineItemTemplateAnalysisRouteKey', variant: 'routeEditVariant'}
              },
              'leftPanel@app.adv.line-item-templates.line-item-template': {
                component: AdminResourceItemRoutePageComponent,
                bindings: {
                  item: 'lineItemTemplateEditRouteKey',
                  variant: 'routeEditVariant',
                  inputOverrides: 'lineItemTemplateEditInputs'
                }
              },
              'context@app': {
                component: LineItemTemplateContextActionsComponent,
                bindings: {
                  model: 'model', modelComms: 'modelComms', isNew: 'isNew',
                  readOnly: 'readOnly', sectionParam: 'sectionParam'
                }
              }
            }
          }, 'LineItemTemplate'));
  }, adnRouterHelper);
}
